


export default function Preferences ({}) {
    const OptionSeat = ["חלון", "מעבר"];
    const OptionMeal = ["ארוחה כשרה", "טבעוני"];

    return (
    <>
        <div className="divOfPrefer">
            <p> הושבה </p>
            <select> {OptionSeat.map((value, key) => <option key={key}> {value} </option>)} </select>
            <p> אוכל </p>
            <select> {OptionMeal.map((value, key) => <option key={key}> {value} </option>)} </select>
        </div>
    </>
    )
}